import { appendPath, getValue, parentPath } from '@truqc/content-path';
import { createSelector } from 'reselect';
import newPathSelector from './newPathSelector';
import { getContent } from './simpleSelectors';
const getConformance = (state, {
  format: {
    conformance
  }
}) => conformance;
const getErrorText = (state, {
  format: {
    errorText
  }
}) => errorText;
export default createSelector([getContent, getConformance, newPathSelector, getErrorText], (content, conformance, path, errorText) => {
  if (errorText) {
    return errorText;
  }
  if (!conformance) {
    return null;
  }
  const {
    contentPath,
    errorText: legacyErrorText
  } = conformance;
  if (!contentPath || !legacyErrorText) {
    return null;
  }
  const conforms = getValue(appendPath(parentPath(path), contentPath), content);
  if (conforms === undefined) {
    return null;
  }
  return conforms ? null : legacyErrorText;
});